import Abstract from './abstract';

const CONTAINER = '[data-voc-pw-last-news]';

class LastContent extends Abstract {
  constructor() {
    super(CONTAINER, ...arguments);
    this.priority = 0;
    this.final    = true;
  }

  show() {
    const maxValue = parseInt(this.config.max), countValue = parseInt(this.config.count);
    const leftValue = maxValue - countValue;

    if(this.config.isExtra === 'false' && !this.isViewed() && leftValue === 0 && !this.isMeterExceeded()) {
      super.show();
      return true;
    }

    return false;
  }
}

export default LastContent;



// WEBPACK FOOTER //
// ./src/alerts/last-content.js